<template>
  <!-- 收藏统计 -->
  <div class="userAnalysis">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['数据分析', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">账号状态：</label>
        <el-select
          placeholder="账号状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="已审核" value="2"></el-option>
          <el-option label="未审核" value="1"></el-option>
        </el-select>
        <label class="label">证书状态：</label>
        <el-select
          placeholder="证书状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.type"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="正常" value="正常"></el-option>
          <el-option label="过期" value="过期"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入关键字"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userId"
        align="center"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="erpCode"
        width="120"
        align="center"
        show-overflow-tooltip
        label="ERP编号"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        width="120"
        align="center"
        show-overflow-tooltip
        label="客户名称"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="address"
        width="120"
        align="center"
        show-overflow-tooltip
        label="送货地址">
      </el-table-column> -->
      <el-table-column
        prop="salezMan"
        align="center"
        show-overflow-tooltip
        label="销售员"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="billingClerk"
        align="center"
        show-overflow-tooltip
        label="开票员">
      </el-table-column>
      <el-table-column
        prop="department"
        align="center"
        show-overflow-tooltip
        label="部门">
      </el-table-column>
      <el-table-column
        prop="userType"
        align="center"
        show-overflow-tooltip
        label="企业分类">
      </el-table-column> -->
      <!-- <el-table-column
        prop="status"
        align="center"
        show-overflow-tooltip
        label="证书状态"
      >
      </el-table-column>
      <el-table-column
        prop="endLink"
        width="100"
        align="center"
        show-overflow-tooltip
        label="末次浏览日期"
      >
      </el-table-column>
      <el-table-column
        prop="startDate"
        width="100"
        align="center"
        show-overflow-tooltip
        label="首次成交日期"
      >
      </el-table-column>
      <el-table-column
        prop="endDate"
        width="100"
        align="center"
        show-overflow-tooltip
        label="末次成交日期"
      >
      </el-table-column>
      <el-table-column
        prop="drainDate"
        align="center"
        show-overflow-tooltip
        label="流失天数"
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="drainGroup"
        align="center"
        show-overflow-tooltip
        label="流失天数组"
      >
      </el-table-column> -->
      <el-table-column
        prop="buyOrder7"
        align="center"
        show-overflow-tooltip
        label="7天内采购频次"
      >
      </el-table-column>
      <el-table-column
        prop="buyOrder15"
        align="center"
        show-overflow-tooltip
        label="15天内采购频次"
      >
      </el-table-column>
      <el-table-column
        prop="buyOrder30"
        align="center"
        show-overflow-tooltip
        label="30天内采购频次"
      >
      </el-table-column>
      <el-table-column
        prop="buyOrder60"
        align="center"
        show-overflow-tooltip
        label="31~60天采购频次"
      >
      </el-table-column>
      <el-table-column
        prop="buyGoods7"
        align="center"
        show-overflow-tooltip
        label="7天内采购品规数"
      >
      </el-table-column>
      <el-table-column
        prop="buyGoods15"
        align="center"
        show-overflow-tooltip
        label="15天内采购品规数"
      >
      </el-table-column>
      <el-table-column
        prop="buyGoods30"
        align="center"
        show-overflow-tooltip
        label="30天内采购品规数"
      >
      </el-table-column>
      <el-table-column
        prop="buyGoods60"
        align="center"
        show-overflow-tooltip
        label="31~60天采购品规数"
      >
      </el-table-column>
      <el-table-column
        prop="buyPrice7"
        align="center"
        show-overflow-tooltip
        label="7天内采购金额"
      >
      </el-table-column>
      <el-table-column
        prop="buyPrice15"
        align="center"
        show-overflow-tooltip
        label="15天内采购金额"
      >
      </el-table-column>
      <el-table-column
        prop="buyPrice30"
        align="center"
        show-overflow-tooltip
        label="30天内采购金额"
      >
      </el-table-column>
      <el-table-column
        prop="buyPrice60"
        align="center"
        show-overflow-tooltip
        label="31~60天采购金额"
      >
      </el-table-column>
      <el-table-column
        prop="monthPrice"
        align="center"
        show-overflow-tooltip
        label="月均金额"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "userAnalysis",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        status: "99",
        type: "",
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "CustomerOperationData",
        accountStatus: this.searchForm.status,
        certificateStatus: this.searchForm.type,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              userId: item.userid, // 客户编号
              erpCode: item.erp_dwbh, // ERP编号
              userName: item.businessname, // 客户名称
              address: item.shouhdz, // 送货地址
              salezMan: item.salezMan, // 销售员
              billingClerk: item.BillingSupervisor, // 开票员
              department: item.Department, // 部门
              userType: item.clienttype, // 企业分类
              status: item.CredentialStatus, // 证书状态
              endLink: item.mcllrq, // 末次浏览日期
              startDate: item.FirstSaleDate, // 首次成交日期
              endDate: item.LastSaleDate, // 末次成交日期
              drainDate: item.lsts, // 流失天数
              drainGroup: item.lstsz, // 流失天数组
              buyOrder7: item.sevenpc, // 7天内采购频次
              buyOrder15: item.fifteenpc, // 15天内采购频次
              buyOrder30: item.thirtypc, // 30天内采购频次
              buyOrder60: item.sixtypc, // 31~60天采购频次
              buyGoods7: item.sevenpg, // 7天内采购品规数
              buyGoods15: item.fifteenpg, // 15天内采购品规数
              buyGoods30: item.thirtypg, // 30天内采购品规数
              buyGoods60: item.sixtypg, // 31~60天采购品规数
              buyPrice7: item.sevenje, // 7天内采购金额
              buyPrice15: item.fifteenje, // 15天内采购金额
              buyPrice30: item.thirtyje, // 30天内采购金额
              buyPrice60: item.sixtyje, // 31~60天采购金额
              monthPrice: item.yjje, // 月均金额
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    exportData() {
      let data = {
        type: "CustomerOperationData",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        accountStatus: this.searchForm.status,
        certificateStatus: this.searchForm.type,
        strWhere: this.searchForm.name,
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_Admin_Statistical"; // 存储过程名
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=客户分析";
    },
  },
};
</script>

<style scoped>
.userAnalysis {
  width: 100%;
  height: 100%;
}
</style>
